import { RETRIEVE_ORDER_FOR_LOCKER_DETAIL_CONSTANTS, RETRIEVE_PRODUCT_DETAIL_CONSTANTS } from './actions/customer.product.detail.actions';
import Immutable from 'seamless-immutable';
export var INITIAL_STATE = Immutable({
  data: null,
  orderData: null,
  isFetchingData: null
});
export default function productDetailReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case RETRIEVE_ORDER_FOR_LOCKER_DETAIL_CONSTANTS.BEGIN:
      return state.set('isFetchingData', true).set('productDetailError', null);
    case RETRIEVE_ORDER_FOR_LOCKER_DETAIL_CONSTANTS.SUCCESS:
      return state.set('orderData', payload.Order).set('isFetchingData', false).set('productDetailError', null);
    case RETRIEVE_ORDER_FOR_LOCKER_DETAIL_CONSTANTS.FAILURE:
      return state.set('isFetchingData', false).set('productDetailError', {
        code: payload.Code,
        message: payload.translatedMessage,
        severity: payload.Severity
      });
    case RETRIEVE_PRODUCT_DETAIL_CONSTANTS.BEGIN:
      return state.set('isFetchingData', true).set('productDetailError', null);
    case RETRIEVE_PRODUCT_DETAIL_CONSTANTS.SUCCESS:
      return state.set('data', payload).set('isFetchingData', false).set('productDetailError', null);
    case RETRIEVE_PRODUCT_DETAIL_CONSTANTS.FAILURE:
      return state.set('isFetchingData', false).set('productDetailError', {
        code: payload.Code,
        message: payload.translatedMessage,
        severity: payload.Severity
      });
    default:
      return state;
  }
}